import script from "./FormularioProveedor.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormularioProveedor.vue?vue&type=script&setup=true&lang=ts"

import "./FormularioProveedor.vue?vue&type=style&index=0&id=5cefa5c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cefa5c6"]])

export default __exports__